// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from './application'

import ResetFormController from './reset_form_controller.js'
application.register('reset-form', ResetFormController)
